import type { Form } from '../../../common/types/form';
import type { Client } from '../../../common/types/client';

const phoneForm: Form<Client> = {
  key: 'phoneForm',
  fields: [
    {
      key: 'request',
      label: 'Anliegen',
      fieldTypes: 'checkboxSelect',
      xsWidth: 12,
      options: [
        {
          value: 'infoAboutEatingDisorder',
          label: 'Info über Essstörung allgemein',
        },
        {
          value: 'infoAboutTreatmentOptions',
          label: 'Info über Behandlungsmöglichkeiten',
        },
        {
          value: 'infoAboutDealingWithDisease',
          label: 'Info über Umgang mit einer Erkrankung',
        },
        {
          value: 'infoAboutHandlingWithRelatives',
          label: 'Info über Umgang mit der Erkr. bei Angeh. / Freund*innen / Kolleg*innen',
        },
        {
          value: 'registrationForConsultation',
          label: 'Anmeldung zur Beratung',
        },
        {
          value: 'crisisintervention',
          label: 'Krisenintervention',
        },
        {
          value: 'nutritionalCounseling',
          label: 'Ernährungsberatung',
        },
        {
          value: 'other',
          label: 'Sonstiges',
        },
      ],
    },
    {
      key: 'otherRequest',
      label: 'Sonstige Anliegen',
      fieldTypes: 'text',
      isVisible: (client) => client.request != null && client.request.includes('other'),
    },
    {
      key: 'measuresTakenSoFar',
      label: 'Bisherige Maßnahmen',
      fieldTypes: 'checkboxSelect',
      xsWidth: 12,
      options: [
        {
          value: 'none',
          label: 'Keine',
        },
        {
          value: 'ambulantTherapy',
          label: 'ambulante Einzeltherapie',
        },
        {
          value: 'stationaryTherapy',
          label: 'stationäre Therapie',
        },
        {
          value: 'consulting',
          label: 'Beratung',
        },
        {
          value: 'medicalTreatment',
          label: 'ärztliche Behandlung',
        },
        {
          value: 'psychiatricTreatment',
          label: 'psychiatrische Behandlung',
        },
        {
          value: 'nutritionadvice',
          label: 'Ernährungsberatung',
        },
        {
          value: 'group',
          label: 'Gruppe',
        },
      ],
    },
    {
      key: 'group',
      label: 'Gruppe, und zwar',
      fieldTypes: 'text',
      isVisible: (client) => client.measuresTakenSoFar != null && client.measuresTakenSoFar.includes('group'),
    },
    {
      key: 'durationOfConsultation',
      label: 'Dauer der Beratung',
      fieldTypes: 'select',
      options: [
        {
          value: 'shortConsultation',
          label: 'Kurzberatung (bis 15 Minuten)',
        },
        {
          value: 'consultation',
          label: 'Beratung (15 - 30 Minuten)',
        },
        {
          value: 'longerConsultation',
          label: 'längere Beratung (über 30 Minuten)',
        },
      ],
    },
  ],
};

export default phoneForm;
